module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "information-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appid),
      expression: "formData.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "name",
      "placeholder": "name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "description",
      "placeholder": "description"
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.version),
      expression: "formData.version"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "version",
      "placeholder": "version"
    },
    domProps: {
      "value": (_vm.formData.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "version", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("No8version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.no8version),
      expression: "formData.no8version"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "no8version",
      "placeholder": "no8version"
    },
    domProps: {
      "value": (_vm.formData.no8version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "no8version", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Uppermd5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.uppermd5),
      expression: "formData.uppermd5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "uppermd5",
      "placeholder": "uppermd5"
    },
    domProps: {
      "value": (_vm.formData.uppermd5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "uppermd5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Upperurl")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.upperurl),
      expression: "formData.upperurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "upperurl",
      "placeholder": "upperurl"
    },
    domProps: {
      "value": (_vm.formData.upperurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "upperurl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowermd5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowermd5),
      expression: "formData.lowermd5"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowermd5",
      "placeholder": "lowermd5"
    },
    domProps: {
      "value": (_vm.formData.lowermd5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowermd5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowerurl")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowerurl),
      expression: "formData.lowerurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowerurl",
      "placeholder": "lowerurl"
    },
    domProps: {
      "value": (_vm.formData.lowerurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowerurl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowermd5nostm8")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowermd5nostm8),
      expression: "formData.lowermd5nostm8"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowermd5nostm8",
      "placeholder": "lowermd5nostm8"
    },
    domProps: {
      "value": (_vm.formData.lowermd5nostm8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowermd5nostm8", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lowerurlnostm8")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowerurlnostm8),
      expression: "formData.lowerurlnostm8"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "lowerurlnostm8",
      "placeholder": "lowerurlnostm8"
    },
    domProps: {
      "value": (_vm.formData.lowerurlnostm8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowerurlnostm8", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Logic")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.logic),
      expression: "formData.logic"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isSuperAdmin,
      "name": "logic",
      "placeholder": "logic"
    },
    domProps: {
      "value": (_vm.formData.logic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "logic", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75d19574", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75d19574"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/DeviceTypesForm.vue
// module id = 485
// module chunks = 1